import '../../css/layout/header.css';
import { Link } from 'react-router-dom';
import { useApp } from "../../hooks/AppProvider";
import { useEffect, useState } from 'react';

function Header({ hideAction }) {
    let app = useApp();

    let [countdown, setCountdown] = useState(0);

    useEffect(() => {
        if(app.maintenance.time == null)
            return;

        let currentTime = new Date().getTime();
        let inter = app.maintenance.time - currentTime;
        setCountdown(Math.floor((inter / 1000) / 60));

        const interval = setInterval(() => {
            if(countdown < 0) {
                clearInterval(interval);
            }
            let currentTime = new Date().getTime();
            let inter = app.maintenance.time - currentTime;
            setCountdown(Math.floor((inter / 1000) / 60));
        }, 1000);

        return () => clearInterval(interval);

    }, [app.maintenance.time]);

    return (
        <>
        <header className='header-main'>
            <div className='header-left'>
                <div className="hamburger" onClick={hideAction}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            <div className='header-center'>
            <img className='header-img' src='/img/logo_fill_text_64.png' />
            </div>
            <div className='header-right'>
                {app.isLogin() != 0 ? <Link to='/logout'><button>Se déconnecter</button></Link> : <Link to='/login'><button>Se connecter</button></Link>}
            </div>
        </header>
        <div className='maintenance-div' hidden={!app.maintenance.up}>
            <span className='maintenance-text'>Une maintenance est {countdown < 0 ? ("en cours. Veuillez patienter et réessayer plus tard.") : ("prévue dans " + countdown + " minute" + (countdown > 1 ? ("s") : ("")) + ". Pensez à enregistrer vos modifications !") } </span>
        </div>
        </>
    );
}

export default Header;